import { Component } from '@angular/core';

@Component({
    selector: 'app-default-layout',
    template: `
    <app-header></app-header>
    <div class="page-content">
        <router-outlet />
    </div>
    <app-footer></app-footer>
  `,
    styles: `
    .page-content {
        padding-top: 160px;
        min-height: 100dvh;
        background-color: rgba(0, 0, 0, 0.5);
        padding-bottom: 48px;
    }
  `,
    standalone: false
})
export class DefaultLayoutComponent {}